var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9864 5.57661L10.3453 5.04972L8.71787 1.77461C8.42628 1.19083 7.58142 1.18341 7.28734 1.77461L5.65993 5.04972L2.01881 5.57661C1.36586 5.67061 1.10417 6.4696 1.57769 6.92723L4.21196 9.47509L3.5889 13.0743C3.47676 13.7248 4.1671 14.2121 4.74529 13.9079L8.0026 12.2085L11.2599 13.9079C11.8381 14.2097 12.5285 13.7248 12.4163 13.0743L11.7933 9.47509L14.4275 6.92723C14.901 6.4696 14.6394 5.67061 13.9864 5.57661Z",
    fill: "#FFA446"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFillIcon);
export default __webpack_public_path__ + "static/media/starFillIcon.41c0fd29.svg";
export { ForwardRef as ReactComponent };